import React, { Component, Fragment } from "react";
import Accordion from "./Accordion";
import config from "../config.json";

export default class User extends Component {
  state = {
    categoryPoints: {},
    totalPoints: 0,
  };

  componentDidMount = async () => {
    const { categoryPoints, totalPoints } = this.props.calculateTotalPoints(
      this.props.user
    );

    this.setState({
      ...this.state,
      categoryPoints: categoryPoints,
      totalPoints: totalPoints,
    });
  };

  renderNotification = (notification, index) => {
    const formatDate = (date, includeYear = false) => {
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${day < 10 ? "0" : ""}${day}/${month < 10 ? "0" : ""}${month}${
        includeYear ? "/" + date.getUTCFullYear() : ""
      }`;
    };

    return (
      <div
        key={index}
        style={{
          marginBottom: "10px",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      >
        {notification.image && (
          <img
            style={{ width: "50px" }}
            className="organization-image"
            src={`${config.s3.notificationImagesUrl + notification.image}`}
          />
        )}
        <div
          style={{
            padding: "10px 15px",
            background: "#f0f0f0",
            fontWeight: "bold",
          }}
        >
          {notification.title}
        </div>
        <div style={{ padding: "10px 15px", background: "#f9f9f9" }}>
          {notification.message}
        </div>
        <div style={{ padding: "10px 15px", background: "#f9f9f9" }}>
          {formatDate(new Date(notification.timestamp))}
        </div>
      </div>
    );
  };

  renderCategoryPoint = (categoryKey, index) => {
    return (
      <div className="product-id" key={index}>
        {" "}
        {categoryKey} : {this.state.categoryPoints[categoryKey]}{" "}
      </div>
    );
  };

  render() {
    return (
      <div className="tile is-child box notification">
        <div>
          <p className="product-title">{this.props.user.userName}</p>
          <p className="product-id">Pushtoken:{this.props.user.pushToken}</p>
          <p className="product-id">Email: {this.props.user.email}</p>
          <p className="product-id">Hold: {this.props.user.team}</p>
          <p className="product-id">Point: {this.props.user.totalPoints}</p>

          <p className="product-id">Ægte Point: {this.state.totalPoints}</p>
          <Accordion
            items={Object.keys(this.state.categoryPoints)}
            renderComponent={this.renderCategoryPoint}
            title="Se ægte point"
          />

          <p className="product-id">
            Inaktiv: {this.props.user.inactive ? "Ja" : "Nej"}
          </p>
          <p className="product-id">id: {this.props.user.id}</p>
          <Accordion
            items={this.props.user.notifications}
            renderComponent={this.renderNotification}
            title="Se notifikationer"
          />

          <button
            onClick={() => {
              if (window.confirm("Sikker?")) {
                this.props.deleteUser(
                  this.props.user.id,
                  this.props.user.email
                );
              }
            }}
          >
            Slet bruger
          </button>
        </div>
      </div>
    );
  }
}
